export interface ActivityProps {
  id: number;
  type: 'checklist-complete' | 'assignment-complete' | 'payment-received';
  title: string;
  event: {
    name: string;
    type: string;
  };
  notes: string;
  date: string;
  time: string;
}

export const activity: ActivityProps[] = [
  {
    id: 1,
    type: 'checklist-complete',
    title: 'Pre-wedding venue inspection completed',
    event: {
      name: 'Johnson-Smith Wedding',
      type: 'Wedding'
    },
    notes: 'All items verified. Backup generator confirmed available.',
    date: '2025-11-05',
    time: '14:30'
  },
  {
    id: 2,
    type: 'payment-received',
    title: 'Final payment processed',
    event: {
      name: 'Tech Corp Annual Gala',
      type: 'Corporate Event'
    },
    notes: 'Payment received via wire transfer. Invoice #INV-2847 closed.',
    date: '2025-11-04',
    time: '09:15'
  },
  {
    id: 3,
    type: 'assignment-complete',
    title: 'Catering menu finalized',
    event: {
      name: 'Martinez 50th Birthday',
      type: 'Birthday Party'
    },
    notes: 'Client approved vegetarian and gluten-free options. 85 guests confirmed.',
    date: '2025-11-03',
    time: '16:45'
  },
  {
    id: 4,
    type: 'checklist-complete',
    title: 'Sound system testing completed',
    event: {
      name: 'Summer Music Festival',
      type: 'Festival'
    },
    notes: 'All equipment functional. Backup microphones staged.',
    date: '2025-11-02',
    time: '11:20'
  },
  {
    id: 5,
    type: 'payment-received',
    title: 'Deposit received',
    event: {
      name: 'Chen-Lee Wedding',
      type: 'Wedding'
    },
    notes: '50% deposit confirmed. Remaining balance due by Nov 20.',
    date: '2025-11-01',
    time: '13:00'
  },
  {
    id: 6,
    type: 'assignment-complete',
    title: 'Vendor contracts signed',
    event: {
      name: 'Holiday Charity Fundraiser',
      type: 'Fundraiser'
    },
    notes: 'Florist, photographer, and DJ contracts secured. All insurance verified.',
    date: '2025-10-31',
    time: '10:30'
  },
  {
    id: 7,
    type: 'checklist-complete',
    title: 'Guest seating arrangements finalized',
    event: {
      name: 'Anderson Retirement Party',
      type: 'Retirement Party'
    },
    notes: 'All 120 guests assigned tables. Dietary restrictions noted.',
    date: '2025-10-30',
    time: '15:15'
  },
  {
    id: 8,
    type: 'payment-received',
    title: 'Second installment received',
    event: {
      name: 'Product Launch Event',
      type: 'Corporate Event'
    },
    notes: 'Payment cleared. 30% remaining due post-event.',
    date: '2025-10-29',
    time: '08:45'
  },
  {
    id: 9,
    type: 'assignment-complete',
    title: 'Decorations delivered and approved',
    event: {
      name: 'Williams Baby Shower',
      type: 'Baby Shower'
    },
    notes: 'Blue and gold theme confirmed. Balloon arch installed successfully.',
    date: '2025-10-28',
    time: '12:00'
  },
  {
    id: 10,
    type: 'checklist-complete',
    title: 'Emergency protocols reviewed',
    event: {
      name: 'Downtown Food Festival',
      type: 'Festival'
    },
    notes: 'Security briefing completed. Medical team and exits confirmed.',
    date: '2025-10-27',
    time: '09:00'
  }
]
